import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

// services
import {CarsService} from "../../../shared/services/cars.service";
import {SnackbarService} from "../../../shared/services/snackbar.service";

// models
import {ApiMessage} from "../../../shared/models/api-message";


@Component({
    selector: 'app-car-completed-modal',
    templateUrl: './car-completed-modal.component.html',
    styleUrl: './car-completed-modal.component.scss'
})
export class CarCompletedModalComponent {

    public carID = 0;
    public checked = false;
    public isSaved = false;

    constructor(private carsService: CarsService,
                private snackbarService: SnackbarService,
                private dialogRef: MatDialogRef<CarCompletedModalComponent>,
                @Inject(MAT_DIALOG_DATA)
                data: {
                    carID: number
                }) {
        this.carID = data.carID;
    }

    public completed(): void {
        this.isSaved = true;
        const carData = {
            status: true,
        };
        this.carsService.updateCar(this.carID, carData).subscribe({
            next: (res: ApiMessage): void => {
                this.snackbarService.snackbarCustomComplete(res.message);
            },
            error: (e) => this.snackbarService.snackbarCustomError(e.error.message),
            complete: () => {
                this.isSaved = false;
                this.dialogRef.close();
            }
        })
    }
}
